import React from "react";

/**
 * The component for rendering the Bootstrap modal body.
 *
 * @param {object} props Initial props
 * @returns {object} The React element
 */
function ModalBody(props) {
  return <div className="modal-body">{props.children}</div>;
}

export default ModalBody;
